export default "__VITE_ASSET__BCyiQZ9m__"